import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { BackButtonDesktop } from './components/BackButtonDesktop';
import { BackButtonMobile } from './components/BackButtonMobile';

export interface IBackButtonProps {
  title: string;
  url: string;
}

export const BackButton: React.VFC<IBackButtonProps> = ({ title, url }) => {
  return (
    <>
      <Responsive phone tablet>
        <BackButtonMobile title={title} url={url} />
      </Responsive>
      <Responsive desktop>
        <BackButtonDesktop title={title} url={url} />
      </Responsive>
    </>
  );
};
